export const FREELANCER_UI_GROUPS = {
  task: [
    { currencies: ['USD','AUD','CAD'], range: [10,30] },
    { currencies: ['GBP'], range: [10,20] },
    { currencies: ['EUR'], range: [8,30] },
    { currencies: ['INR'], range: [600,1500] },
    { currencies: ['NZD'], range: [14,30] },
    { currencies: ['SGD'], range: [12,30] },
    { currencies: ['HKD'], range: [80,240] }
  ],
  micro: [
    { currencies: ['USD','AUD','CAD'], range: [30,75] },
    { currencies: ['GBP'], range: [20,60] },
    { currencies: ['EUR'], range: [25,80] },
    { currencies: ['INR'], range: [1500,4000] },
    { currencies: ['NZD'], range: [45,110] },
    { currencies: ['SGD'], range: [30,90] },
    { currencies: ['HKD'], range: [240,600] }
  ],
  entry: [
    { currencies: ['USD','AUD','CAD'], range: [75,150] },
    { currencies: ['GBP'], range: [60,120] },
    { currencies: ['EUR'], range: [70,180] },
    { currencies: ['INR'], range: [4000,10000] },
    { currencies: ['NZD'], range: [120,240] },
    { currencies: ['SGD'], range: [90,200] },
    { currencies: ['HKD'], range: [600,1500] }
  ],
  core: [
    { currencies: ['USD','AUD','CAD'], range: [150,300] },
    { currencies: ['GBP'], range: [120,250] },
    { currencies: ['EUR'], range: [140,320] },
    { currencies: ['INR'], range: [10000,25000] },
    { currencies: ['NZD'], range: [280,560] },
    { currencies: ['SGD'], range: [200,480] },
    { currencies: ['HKD'], range: [1500,3600] }
  ],
  small: [
    { currencies: ['USD','AUD','CAD'], range: [300,600] },
    { currencies: ['GBP'], range: [250,500] },
    { currencies: ['EUR'], range: [280,650] },
    { currencies: ['INR'], range: [25000,50000] },
    { currencies: ['NZD'], range: [560,1100] },
    { currencies: ['SGD'], range: [480,1000] },
    { currencies: ['HKD'], range: [3600,7800] }
  ],
  medium: [
    { currencies: ['USD','AUD','CAD'], range: [600,1500] },
    { currencies: ['GBP'], range: [500,1200] },
    { currencies: ['EUR'], range: [650,1600] },
    { currencies: ['INR'], range: [50000,125000] },
    { currencies: ['NZD'], range: [1100,2600] },
    { currencies: ['SGD'], range: [1000,2400] },
    { currencies: ['HKD'], range: [7800,18000] }
  ],
  business: [
    { currencies: ['USD','AUD','CAD'], range: [1500,3000] },
    { currencies: ['GBP'], range: [1200,2500] },
    { currencies: ['EUR'], range: [1600,3200] },
    { currencies: ['INR'], range: [125000,250000] },
    { currencies: ['NZD'], range: [2600,5200] },
    { currencies: ['SGD'], range: [2400,4800] },
    { currencies: ['HKD'], range: [18000,36000] }
  ],
  pro: [
    { currencies: ['USD','AUD','CAD'], range: [3000,7000] },
    { currencies: ['GBP'], range: [2500,6000] },
    { currencies: ['EUR'], range: [3200,7500] },
    { currencies: ['INR'], range: [250000,600000] },
    { currencies: ['NZD'], range: [5200,12000] },
    { currencies: ['SGD'], range: [4800,11000] },
    { currencies: ['HKD'], range: [36000,84000] }
  ],
  large: [
    { currencies: ['USD','AUD','CAD'], range: [7000,15000] },
    { currencies: ['GBP'], range: [6000,13000] },
    { currencies: ['EUR'], range: [7500,16000] },
    { currencies: ['INR'], range: [600000,1300000] },
    { currencies: ['NZD'], range: [12000,26000] },
    { currencies: ['SGD'], range: [11000,24000] },
    { currencies: ['HKD'], range: [84000,180000] }
  ],
  major: [
    { currencies: ['USD','AUD','CAD'], range: [15000,40000] },
    { currencies: ['GBP'], range: [13000,35000] },
    { currencies: ['EUR'], range: [16000,42000] },
    { currencies: ['INR'], range: [1300000,3500000] },
    { currencies: ['NZD'], range: [26000,70000] },
    { currencies: ['SGD'], range: [24000,65000] },
    { currencies: ['HKD'], range: [180000,500000] }
  ],
  enterprise: [
    { currencies: ['USD','AUD','CAD'], range: [40000,150000] },
    { currencies: ['GBP'], range: [35000,130000] },
    { currencies: ['EUR'], range: [42000,150000] },
    { currencies: ['INR'], range: [3500000,13500000] },
    { currencies: ['NZD'], range: [70000,260000] },
    { currencies: ['SGD'], range: [65000,240000] },
    { currencies: ['HKD'], range: [500000,1900000] }
  ],
};

export const FREELANCER_BUDGETS = {
  task: {
    USD: [10,30], AUD: [10,30], CAD: [10,30], GBP: [10,20], EUR: [8,30], INR: [600,1500], NZD: [14,30], SGD: [12,30], HKD: [80,240]
  },
  micro: {
    USD: [30,250], AUD: [30,250], CAD: [30,250], GBP: [20,250], EUR: [30,250], INR: [1500,12500], NZD: [30,250], SGD: [30,250], HKD: [240,2000]
  },
  entry: {
    USD: [250,750], AUD: [250,750], CAD: [250,750], GBP: [250,750], EUR: [250,750], INR: [12500,37500], NZD: [250,750], SGD: [250,750], HKD: [2000,6000]
  },
  core: {
    USD: [750,1500], AUD: [750,1500], CAD: [750,1500], GBP: [750,1500], EUR: [750,1500], INR: [37500,75000], NZD: [750,1500], SGD: [750,1500], HKD: [6000,12000]
  },
  small: {
    USD: [1500,3000], AUD: [1500,3000], CAD: [1500,3000], GBP: [1500,3000], EUR: [1500,3000], INR: [75000,150000], NZD: [1500,3000], SGD: [1500,3000], HKD: [12000,24000]
  },
  medium: {
    USD: [3000,5000], AUD: [3000,5000], CAD: [3000,5000], GBP: [3000,5000], EUR: [3000,5000], INR: [150000,250000], NZD: [3000,5000], SGD: [3000,5000], HKD: [24000,40000]
  },
  business: {
    USD: [5000,10000], AUD: [5000,10000], CAD: [5000,10000], GBP: [5000,10000], EUR: [5000,10000], INR: [250000,500000], NZD: [5000,10000], SGD: [5000,10000], HKD: [40000,80000]
  },
  pro: {
    USD: [10000,20000], AUD: [10000,20000], CAD: [10000,20000], GBP: [10000,20000], EUR: [10000,20000], INR: [500000,1000000], NZD: [10000,20000], SGD: [10000,20000], HKD: [80000,160000]
  },
  large: {
    USD: [20000,50000], AUD: [20000,50000], CAD: [20000,50000], GBP: [20000,50000], EUR: [20000,50000], INR: [1000000,2500000], NZD: [20000,50000], SGD: [20000,50000], HKD: [160000,400000]
  },
  
};



export function getPresetValue(min, max, preset) {
  if (preset === 'lowest') return min;
  if (preset === 'highest') return max;

  const avg = (min + max) / 2;
  return Math.round(avg); // 112.5 → 113
}

export function getRangeForCurrency(tier, currency) {
  const tierMap = FREELANCER_BUDGETS[tier];
  if (!tierMap) return null;
  const rng = tierMap[currency];
  return Array.isArray(rng) ? rng : null;
}